import { harvestYearDetail } from "../../config/harvestYearDetail";
import { HARVEST_YEAR } from "./action";

const initialState = {
  HarvestYearList: [],
  selectedYear: ""
};

export function harvestYearReducer(state = initialState, action) {
  switch (action.type) {
    case HARVEST_YEAR.getHarvestYear.success:
      return Object.assign({}, state, {
        HarvestYearList: action.data
      });
    case HARVEST_YEAR.selectedYear.success: {
      return {
        ...state,
        selectedYear: action.data || harvestYearDetail().name
      };
    }
    case HARVEST_YEAR.createHarvestYear.success: {
      return {
        ...state
        //HarvestYearList: action.data
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/harvestYearManagement/reducer.js